import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PhoneCode } from 'src/app/core/Models/interfaces/phoneCodes';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { Form, FormArray, FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { CustomValidation } from 'src/app/shared/validators/customValidators';
import { Role } from 'src/app/core/Models/interfaces/role';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { UserManagementService } from 'src/app/features/user-management/service/user-management.service';
import { UserService } from 'src/app/core/Services/user.service';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { SUB_TYPE } from 'src/app/core/Constants/static';

@Component({
  selector: 'app-prov-contact',
  templateUrl: './prov-contact.component.html',
  styleUrls: ['./prov-contact.component.css']
})
export class ProvContactComponent implements OnInit {
  showContact: boolean = true;
  @Input() formGroupName!: string;
  @Input() formSubmitted: boolean = false;
  @Input() userIdExists!: boolean;
  @Input() isEdit: boolean = false;
  @Input('isThirdPartyComp') isThirdPartyComp: boolean = false;
  @Input('isPayer') isPayer:boolean=false;
  rolesList: Role[] = []
  phoneCodes: PhoneCode[] = [];
  isChecked: boolean = false;
  contactForm!: FormGroup;
  showPassword: boolean = false;
  private user!:UserDetails | undefined;
  private subTypes=SUB_TYPE;
  constructor(
    private rootFormGroup: FormGroupDirective,
    private apiService: ProvPayerApiService,
    private form: FormBuilder,
    private toasterandLoader: ToasterService,
    private userManege: UserManagementService,
    private userService:UserService
  ) { }

  ngOnInit(): void {
    this.user=this.userService.getUserInfo()?.userDetails;
    this.contactForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.getAllroles();
    setTimeout(() => {
      (this.contactForm?.controls['contactArray'] as FormArray).controls.forEach((el: any) => {
        el.controls['userName']?.disable();
        el.controls['password']?.disable();
        if (!el.controls['showIsUser'].value) {
          el.controls['isUser']?.disable();
        }
      });
    }, 1000);

    this.getPhoneCodes();
  }
  getPhoneCodes() {
    this.apiService.getPhoneCodes()
      .subscribe({
        next: (response: any) => {

          if (response?.status == 'success') {
            const phoneCodes: PhoneCode[] = response.data || [];
            this.phoneCodes = phoneCodes.map(phoneCode => {
              phoneCode.countryFlag = `./assets/images/flags/${phoneCode.countryCode}.png`;
              return phoneCode;
            });

            this.phoneCodes.sort(function (a, b) {
              var textA = a.countryName.toUpperCase();
              var textB = b.countryName.toUpperCase();
              return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            this.patchPhoneCode();
          }
        },
        error: (error: any) => { }
      });
  }
  get contactDetailsForm(): FormGroup[] {
    return (
      this.contactForm?.controls['contactArray'] as FormArray)?.controls as FormGroup[];
  }
  get contactDetailsArray(): FormArray {
    return this.contactForm?.controls['contactArray'] as FormArray;
  }
  patchPhoneCode() {
    (this.contactForm?.controls['contactArray'] as FormArray).controls.forEach((el: any) => {

      if (el.controls['phoneCode']?.valid && this.phoneCodes?.length) {
        const val = this.phoneCodes.find((el1: PhoneCode) => el1.phoneCodeId == el.controls['phoneCode']?.value?.phoneCodeId);
        if (val) {
          el.patchValue({ phoneCode: val });
        }
      }
    })
  }
  addContactForm() {
    const newContact = this.form.group({
      firstName: new FormControl(null, Validators.required),
      middleName: new FormControl(null,),
      lastName: new FormControl(null,),
      position: new FormControl(null, Validators.required),
      phoneCode: new FormControl(null, Validators.required),
      contactNumber: new FormControl(null, [CustomValidation.onlyNumber, Validators.required]),
      contactEmail: new FormControl(null, [CustomValidation.email, Validators.required]),
      isUser: new FormControl(null),
      showIsUser: new FormControl(true),
      isUserIdExists: new FormControl(true),
      userName: new FormControl(null, [CustomValidation.email]),
      password: new FormControl(null, [CustomValidation.PasswordRule]),
      isChecked: new FormControl(false),
      isUserMailExist: new FormControl(false)


    });
    newContact.controls['userName']?.disable();
    newContact.controls['password']?.disable();
    this.contactDetailsArray.push(newContact);

  }

  removeElement(index: number, form: FormGroup) {
    this.contactDetailsArray.removeAt(index);
  }
  checkUser(event: any, form: FormGroup) {

    if (event.target.checked) {
      form?.controls['isChecked']?.patchValue(true);
      form?.controls['isUser']?.patchValue(1);
      form?.controls['userName']?.enable();
      form?.controls['password']?.enable();
      form.controls['userName']?.addValidators(CustomValidation.email);
      form.controls['password']?.addValidators(CustomValidation.PasswordRule);
      form.controls['userName']?.updateValueAndValidity();
      form.controls['password']?.updateValueAndValidity();

    } else {
      form?.controls['isChecked']?.patchValue(false);
      form?.controls['isUser']?.patchValue(0);
      form?.controls?.['userName']?.patchValue('');
      form?.controls?.['password']?.patchValue('');
      form.controls['userName']?.disable();
      form.controls['password']?.disable();
    }
  }
  checkUserExist(mailId: string, form: FormGroup) {
    if (mailId) {
      if (this.isEdit && this.contactDetailsForm[0] == form) {
        this.contactDetailsForm[0]?.controls['isUserMailExist']?.patchValue(false);
        return
      } else {
        let username = { username: mailId }
        this.apiService.checkUserExist(username).subscribe({
          next: (response) => {
            if (response.message == 'User Exist Already') {
              form?.controls['isUserMailExist']?.patchValue(true);
            } else {
              form?.controls['isUserMailExist']?.patchValue(false);
            }
          },
          error: (error) => {
          },
        })
      }
    }
  }
  resetkey(formControl: any) {
    if (formControl) {
      formControl.patchValue(false)
    }
    return false;
  }
  resetEmailCheckKey(form: FormGroup): boolean {
    if (form?.controls?.['contactEmail']?.value) {
      return true;
    } else {
      form?.controls?.['isUserMailExist']?.patchValue(false);
      return false;
    }
  }
  getAllroles(): void {
    this.toasterandLoader.isLoaderEnable(true);
    let subType='';
    if(this.user?.userType==1){
      if(this.isPayer){
        subType=this.subTypes.payer;
      }
      else{
        subType=this.subTypes.provider;
      }
    }
    this.userManege.getAllRoles({subType:subType}).subscribe({
      next: (res) => {
        this.rolesList = res?.data?.data;
        this.toasterandLoader.isLoaderEnable(false);
      }, error: (err) => {
        this.toasterandLoader.isLoaderEnable(false);
      }
    })
  }
}
